import { ThemeEvents } from '@theme/events';

/**
 * Sends the shopper to the cart page once a product has been added to the cart.
 *
 * `CartAddEvent` reuses the `cart:update` event name of `CartUpdateEvent`, so `source` is
 * the only way to tell an add-to-cart apart from a quantity change or a line removal.
 *
 * @param {CustomEvent} event - The cart update event.
 */
const redirectToCart = (event) => {
  const data = event.detail && event.detail.data;

  if (!data || data.source !== 'product-form-component' || data.didError) return;

  const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';

  window.location.assign(cartUrl);
};

document.addEventListener(ThemeEvents.cartUpdate, redirectToCart);
